import type { DropzoneOptions } from 'react-dropzone';
import { maxFileSize } from 'utils/constants';
import { FilesUploadStore } from './filesUploadStoreFactory';
import useCustomDropzoneStore, {
  CustomDropzoneConfig,
} from './useCustomDropzoneStore';

const useDomainDropzoneStore = (
  config: CustomDropzoneConfig,
  storeAPI: FilesUploadStore,
  acceptedFileTypes: DropzoneOptions['accept'],
) => {
  return useCustomDropzoneStore(
    {
      onUpload: config.onUpload,
      options: (filesMeta) => ({
        maxSize: maxFileSize,
        accept: acceptedFileTypes,
        ...(typeof config.options === 'function'
          ? config.options(filesMeta)
          : config.options),
      }),
      scheduler: config.scheduler,
      defaultSchedulerOptions: config.defaultSchedulerOptions,
    },
    storeAPI,
  );
};

export default useDomainDropzoneStore;
